






































import { Component, Inject, Vue } from 'vue-property-decorator'
import { BranchAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { Gender, Role } from '@/api/types'
import { Branch } from '@/api/model/branch'

@Component
export default class CompanySettingsTeamsCreate extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    team: Branch = null
    saving: boolean = false

    created(): void {
        this.team = Branch.fromData({
            company: this.$currentCompany,
            id: uuid(),
            firstname: null,
            middlename: null,
            lastname: null,
            avatar: null,
            avatarUrl: null,
            email: null,
            password: null,
            role: Role.EMPLOYEE,
            birthdate: null,
            gender: Gender.UNKNOWN,
            branches: [],
        })
    }

    async save(): Promise<void> {
        this.saving = true
        this.team = await BranchAPI.create(this.team)
        await this.reloadCompany()
        this.saving = false
        await this.$router.push({ name: 'company_settings_teams_list' })
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_teams_list',
        })
    }
}
